import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_validationRules } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoValidatorAdapterComponent = /*#__PURE__*/(() => {
  class DxoValidatorAdapterComponent extends NestedOption {
    get applyValidationResults() {
      return this._getOption('applyValidationResults');
    }
    set applyValidationResults(value) {
      this._setOption('applyValidationResults', value);
    }
    get bypass() {
      return this._getOption('bypass');
    }
    set bypass(value) {
      this._setOption('bypass', value);
    }
    get focus() {
      return this._getOption('focus');
    }
    set focus(value) {
      this._setOption('focus', value);
    }
    get getValue() {
      return this._getOption('getValue');
    }
    set getValue(value) {
      this._setOption('getValue', value);
    }
    get reset() {
      return this._getOption('reset');
    }
    set reset(value) {
      this._setOption('reset', value);
    }
    get validationRequestsCallbacks() {
      return this._getOption('validationRequestsCallbacks');
    }
    set validationRequestsCallbacks(value) {
      this._setOption('validationRequestsCallbacks', value);
    }
    get _optionPath() {
      return 'adapter';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoValidatorAdapterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValidatorAdapterComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoValidatorAdapterComponent,
      selectors: [["dxo-validator-adapter"]],
      inputs: {
        applyValidationResults: "applyValidationResults",
        bypass: "bypass",
        focus: "focus",
        getValue: "getValue",
        reset: "reset",
        validationRequestsCallbacks: "validationRequestsCallbacks"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoValidatorAdapterComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoValidatorAdapterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoValidatorAdapterModule = /*#__PURE__*/(() => {
  class DxoValidatorAdapterModule {
    /** @nocollapse */static ɵfac = function DxoValidatorAdapterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoValidatorAdapterModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoValidatorAdapterModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoValidatorAdapterComponent]
    });
  }
  return DxoValidatorAdapterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorAsyncRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorAsyncRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'async';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorAsyncRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorAsyncRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorAsyncRuleComponent,
      selectors: [["dxi-validator-async-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        reevaluate: "reevaluate",
        type: "type",
        validationCallback: "validationCallback"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorAsyncRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorAsyncRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorAsyncRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorAsyncRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorAsyncRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorAsyncRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorAsyncRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorAsyncRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorAsyncRuleComponent]
    });
  }
  return DxiValidatorAsyncRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorCompareRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorCompareRuleComponent extends CollectionNestedOption {
    get comparisonTarget() {
      return this._getOption('comparisonTarget');
    }
    set comparisonTarget(value) {
      this._setOption('comparisonTarget', value);
    }
    get comparisonType() {
      return this._getOption('comparisonType');
    }
    set comparisonType(value) {
      this._setOption('comparisonType', value);
    }
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'compare';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorCompareRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorCompareRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorCompareRuleComponent,
      selectors: [["dxi-validator-compare-rule"]],
      inputs: {
        comparisonTarget: "comparisonTarget",
        comparisonType: "comparisonType",
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorCompareRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorCompareRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorCompareRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorCompareRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorCompareRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorCompareRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorCompareRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorCompareRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorCompareRuleComponent]
    });
  }
  return DxiValidatorCompareRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorCustomRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorCustomRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'custom';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorCustomRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorCustomRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorCustomRuleComponent,
      selectors: [["dxi-validator-custom-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        reevaluate: "reevaluate",
        type: "type",
        validationCallback: "validationCallback"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorCustomRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorCustomRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorCustomRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorCustomRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorCustomRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorCustomRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorCustomRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorCustomRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorCustomRuleComponent]
    });
  }
  return DxiValidatorCustomRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorEmailRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorEmailRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'email';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorEmailRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorEmailRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorEmailRuleComponent,
      selectors: [["dxi-validator-email-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorEmailRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorEmailRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorEmailRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorEmailRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorEmailRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorEmailRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorEmailRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorEmailRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorEmailRuleComponent]
    });
  }
  return DxiValidatorEmailRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorNumericRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorNumericRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'numeric';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorNumericRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorNumericRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorNumericRuleComponent,
      selectors: [["dxi-validator-numeric-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorNumericRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorNumericRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorNumericRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorNumericRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorNumericRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorNumericRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorNumericRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorNumericRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorNumericRuleComponent]
    });
  }
  return DxiValidatorNumericRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorPatternRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorPatternRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get pattern() {
      return this._getOption('pattern');
    }
    set pattern(value) {
      this._setOption('pattern', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'pattern';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorPatternRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorPatternRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorPatternRuleComponent,
      selectors: [["dxi-validator-pattern-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        message: "message",
        pattern: "pattern",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorPatternRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorPatternRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorPatternRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorPatternRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorPatternRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorPatternRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorPatternRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorPatternRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorPatternRuleComponent]
    });
  }
  return DxiValidatorPatternRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorRangeRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorRangeRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'range';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorRangeRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorRangeRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorRangeRuleComponent,
      selectors: [["dxi-validator-range-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        message: "message",
        min: "min",
        reevaluate: "reevaluate",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorRangeRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorRangeRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorRangeRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorRangeRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorRangeRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorRangeRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorRangeRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorRangeRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorRangeRuleComponent]
    });
  }
  return DxiValidatorRangeRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorRequiredRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorRequiredRuleComponent extends CollectionNestedOption {
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'required';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorRequiredRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorRequiredRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorRequiredRuleComponent,
      selectors: [["dxi-validator-required-rule"]],
      inputs: {
        message: "message",
        trim: "trim",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorRequiredRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorRequiredRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorRequiredRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorRequiredRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorRequiredRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorRequiredRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorRequiredRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorRequiredRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorRequiredRuleComponent]
    });
  }
  return DxiValidatorRequiredRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorStringLengthRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorStringLengthRuleComponent extends CollectionNestedOption {
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'stringLength';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorStringLengthRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorStringLengthRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorStringLengthRuleComponent,
      selectors: [["dxi-validator-string-length-rule"]],
      inputs: {
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        message: "message",
        min: "min",
        trim: "trim",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorStringLengthRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorStringLengthRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorStringLengthRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorStringLengthRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorStringLengthRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorStringLengthRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorStringLengthRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorStringLengthRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorStringLengthRuleComponent]
    });
  }
  return DxiValidatorStringLengthRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiValidatorValidationRuleComponent = /*#__PURE__*/(() => {
  class DxiValidatorValidationRuleComponent extends CollectionNestedOption {
    get message() {
      return this._getOption('message');
    }
    set message(value) {
      this._setOption('message', value);
    }
    get trim() {
      return this._getOption('trim');
    }
    set trim(value) {
      this._setOption('trim', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get ignoreEmptyValue() {
      return this._getOption('ignoreEmptyValue');
    }
    set ignoreEmptyValue(value) {
      this._setOption('ignoreEmptyValue', value);
    }
    get max() {
      return this._getOption('max');
    }
    set max(value) {
      this._setOption('max', value);
    }
    get min() {
      return this._getOption('min');
    }
    set min(value) {
      this._setOption('min', value);
    }
    get reevaluate() {
      return this._getOption('reevaluate');
    }
    set reevaluate(value) {
      this._setOption('reevaluate', value);
    }
    get validationCallback() {
      return this._getOption('validationCallback');
    }
    set validationCallback(value) {
      this._setOption('validationCallback', value);
    }
    get comparisonTarget() {
      return this._getOption('comparisonTarget');
    }
    set comparisonTarget(value) {
      this._setOption('comparisonTarget', value);
    }
    get comparisonType() {
      return this._getOption('comparisonType');
    }
    set comparisonType(value) {
      this._setOption('comparisonType', value);
    }
    get pattern() {
      return this._getOption('pattern');
    }
    set pattern(value) {
      this._setOption('pattern', value);
    }
    get _optionPath() {
      return 'validationRules';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      this.type = 'required';
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiValidatorValidationRuleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorValidationRuleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiValidatorValidationRuleComponent,
      selectors: [["dxi-validator-validation-rule"]],
      inputs: {
        message: "message",
        trim: "trim",
        type: "type",
        ignoreEmptyValue: "ignoreEmptyValue",
        max: "max",
        min: "min",
        reevaluate: "reevaluate",
        validationCallback: "validationCallback",
        comparisonTarget: "comparisonTarget",
        comparisonType: "comparisonType",
        pattern: "pattern"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, {
        provide: PROPERTY_TOKEN_validationRules,
        useExisting: DxiValidatorValidationRuleComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiValidatorValidationRuleComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxiValidatorValidationRuleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiValidatorValidationRuleModule = /*#__PURE__*/(() => {
  class DxiValidatorValidationRuleModule {
    /** @nocollapse */static ɵfac = function DxiValidatorValidationRuleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiValidatorValidationRuleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiValidatorValidationRuleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiValidatorValidationRuleComponent]
    });
  }
  return DxiValidatorValidationRuleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiValidatorAsyncRuleComponent, DxiValidatorAsyncRuleModule, DxiValidatorCompareRuleComponent, DxiValidatorCompareRuleModule, DxiValidatorCustomRuleComponent, DxiValidatorCustomRuleModule, DxiValidatorEmailRuleComponent, DxiValidatorEmailRuleModule, DxiValidatorNumericRuleComponent, DxiValidatorNumericRuleModule, DxiValidatorPatternRuleComponent, DxiValidatorPatternRuleModule, DxiValidatorRangeRuleComponent, DxiValidatorRangeRuleModule, DxiValidatorRequiredRuleComponent, DxiValidatorRequiredRuleModule, DxiValidatorStringLengthRuleComponent, DxiValidatorStringLengthRuleModule, DxiValidatorValidationRuleComponent, DxiValidatorValidationRuleModule, DxoValidatorAdapterComponent, DxoValidatorAdapterModule };
